export default "/_next/static/chunks/fonts/Source Sans Pro BlackIt-30fdfa5b2996e45fbcf714a9f3bb9c44.otf";